/* eslint-disable */
import Vue from "vue";
import App from "./index.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/fontIcon/iconfont.css"//字体图标

Vue.config.productionTip = false;
Vue.use(ElementUI);

new Vue({
  render: h => h(App)
}).$mount("#app");
